// 平台映射
export const platformMap = {
  js: '建设银行',
  zg: '中国银行',
  yz: '邮政银行',
  ny: '农业银行',
  wx: '微信支付',
  nyzz: '农业纸质',
  gs: '工商银行',
  pa: '平安银行',
  xy: '兴业银行',
  jt: '交通银行'
}

// 基础用户列配置
const baseUserColumns = [
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
    fixed: 'left',
    width: 120
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name',
    width: 100
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    key: 'mobile',
    width: 120
  },
  {
    title: '身份证',
    dataIndex: 'idcard',
    key: 'idcard',
    width: 180
  }
]

// 基础交易记录列配置
const baseRecordColumns = [
  {
    title: '交易时间',
    dataIndex: 'transaction_date',
    key: 'transaction_date',
    fixed: 'left',
    width: 180,
    scopedSlots: { customRender: 'transaction_date' }
  },
  {
    title: '交易金额',
    dataIndex: 'transaction_amount',
    key: 'transaction_amount',
    width: 120,
    scopedSlots: { customRender: 'transaction_amount' }
  },
  {
    title: '交易后余额',
    dataIndex: 'balance',
    key: 'balance',
    width: 120
  }
]

// 交易记录操作列
const recordOperationColumn = {
  title: '操作',
  key: 'action',
  fixed: 'right',
  scopedSlots: { customRender: 'operation' }
}

// 银行卡相关列
const bankCardColumns = [
  {
    title: '银行卡号',
    dataIndex: ['card', 'card_num'],
    key: 'card_num',
    width: 180
  },
  {
    title: '开户行',
    dataIndex: ['card', 'sub_bank'],
    key: 'sub_bank',
    width: 150
  },
  {
    title: '余额',
    dataIndex: ['card', 'money'],
    key: 'money',
    width: 120
  },
  {
    title: '开户时间',
    dataIndex: 'createtime',
    key: 'createtime',
    width: 180
  }
]

// 配置对象
export const tableConfig = {
  js: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '商户名称',
          dataIndex: 'merchant_code',
          key: 'merchant_code',
          width: 150
        },
        recordOperationColumn
      ]
    }
  },
  zg: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 180
        },
        {
          title: '对方户名',
          dataIndex: 'counterparty_name',
          key: 'counterparty_name',
          width: 150
        },
        recordOperationColumn
      ]
    }
  },
  yz: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '收支属性',
          dataIndex: 'income_expense_attribute',
          key: 'income_expense_attribute',
          width: 100
        },
        recordOperationColumn
      ]
    }
  },
  ny: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 180
        },
        recordOperationColumn
      ]
    }
  },
  nyzz: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 180
        },
        recordOperationColumn
      ]
    }
  },
  wx: {
    user: {
      columns: [
        ...baseUserColumns,
        {
          title: '余额',
          dataIndex: 'money',
          key: 'money',
          width: 120
        },
        {
          title: '最后登录时间',
          dataIndex: 'last_login_time',
          key: 'last_login_time',
          width: 180
        },
        {
          title: '注册时间',
          dataIndex: 'createtime',
          key: 'createtime',
          width: 180
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '商户名称',
          dataIndex: 'merchant_code',
          key: 'merchant_code',
          width: 150
        },
        recordOperationColumn
      ]
    }
  },
  nyzz: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易类型',
          dataIndex: 'summary',
          key: 'summary',
          width: 100
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 180
        },
        {
          title: '交易摘要',
          dataIndex: 'transaction_summary',
          key: 'transaction_summary',
          width: 150
        },
        recordOperationColumn
      ]
    }
  },
  gs: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易日期',
          dataIndex: 'transaction_date',
          key: 'transaction_date',
          width: 100
        },
        {
          title: '地区号',
          dataIndex: 'region_code',
          key: 'region_code',
          width: 80
        },
        {
          title: '起息日',
          dataIndex: 'value_date',
          key: 'value_date',
          width: 100
        },
        {
          title: '交易代码',
          dataIndex: 'transaction_code',
          key: 'transaction_code',
          width: 100
        },
        {
          title: '发生额',
          dataIndex: 'transaction_amount',
          key: 'transaction_amount',
          width: 120
        },
        {
          title: '摘要',
          dataIndex: 'summary',
          key: 'summary',
          width: 150
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 180
        },
        {
          title: '对方户名',
          dataIndex: 'counterparty_name',
          key: 'counterparty_name',
          width: 150
        },
        {
          title: '储种',
          dataIndex: 'deposit_type',
          key: 'deposit_type',
          width: 80
        },
        {
          title: '渠道',
          dataIndex: 'channel',
          key: 'channel',
          width: 100
        },
        {
          title: '网点号',
          dataIndex: 'branch_code',
          key: 'branch_code',
          width: 100
        },
        {
          title: '操作员',
          dataIndex: 'operator_code',
          key: 'operator_code',
          width: 100
        },
        recordOperationColumn
      ]
    }
  },
  pa: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易地点',
          dataIndex: 'trading_place',
          key: 'trading_place',
          width: 120
        },
        {
          title: '交易网点',
          dataIndex: 'trading_outlet',
          key: 'trading_outlet',
          width: 120
        },
        {
          title: '摘要',
          dataIndex: 'summary',
          key: 'summary',
          width: 150
        },
        {
          title: '附言',
          dataIndex: 'remark',
          key: 'remark',
          width: 150
        },
        {
          title: '备注',
          dataIndex: 'notes',
          key: 'notes',
          width: 150
        },
        {
          title: '交易对手信息',
          dataIndex: 'counterparty_information',
          key: 'counterparty_information',
          width: 200
        },
        recordOperationColumn
      ]
    }
  },
  xy: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '记账日期',
          dataIndex: 'accounting_date',
          key: 'accounting_date',
          width: 120
        },
        {
          title: '摘要',
          dataIndex: 'summary',
          key: 'summary',
          width: 150
        },
        {
          title: '支/收',
          dataIndex: 'income_expense_attribute',
          key: 'income_expense_attribute',
          width: 80
        },
        {
          title: '交易地点',
          dataIndex: 'trading_place',
          key: 'trading_place',
          width: 150
        },
        {
          title: '交易用途',
          dataIndex: 'usage',
          key: 'usage',
          width: 200
        },
        {
          title: '对方户名',
          dataIndex: 'counterparty_name',
          key: 'counterparty_name',
          width: 150
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 160
        },
        {
          title: '对方银行',
          dataIndex: 'counterparty_bank_name',
          key: 'counterparty_bank_name',
          width: 180
        },
        recordOperationColumn
      ]
    }
  },
  // 交通银行：字段对齐《交通银行个人客户交易清单》横版
  jt: {
    user: {
      columns: [
        ...baseUserColumns,
        ...bankCardColumns,
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    record: {
      columns: [
        ...baseRecordColumns,
        {
          title: '交易方式',
          dataIndex: 'summary',
          key: 'summary',
          width: 130
        },
        {
          title: '收支标志',
          dataIndex: 'income_expense_attribute',
          key: 'income_expense_attribute',
          width: 90
        },
        {
          title: '交易地点',
          dataIndex: 'trading_place',
          key: 'trading_place',
          width: 150
        },
        {
          title: '对方户名',
          dataIndex: 'counterparty_name',
          key: 'counterparty_name',
          width: 150
        },
        {
          title: '对方账号',
          dataIndex: 'counterparty_account',
          key: 'counterparty_account',
          width: 160
        },
        recordOperationColumn
      ]
    }
  }
}

// 导出便捷访问方法
export const getUserColumns = (platform) => tableConfig[platform]?.user?.columns || []
export const getRecordColumns = (platform) => tableConfig[platform]?.record?.columns || [] 